import { CURRENCY } from './currency';

/**
 * Country-aware payment method options (UK plan follow-up, 2026-07-30).
 * UPI and Wallet are Indian payment rails — a GB vendor sees Cash/Card/Other.
 * Driven by the login currency scope (GBP ⇒ GB), same signal the rest of the
 * dashboard uses. Call inside the component (not at module scope) so the
 * list reflects the logged-in vendor.
 */
export interface PaymentMethodOption {
  value: string;
  label: string;
  icon: string;
}

export function getPaymentMethods(): PaymentMethodOption[] {
  if (CURRENCY.code === 'GBP') {
    // UK hospitality: contactless/chip card dominates; Apple/Google Pay and
    // gift cards tracked separately for reconciliation; no UPI/Indian wallets.
    return [
      { value: 'CASH', label: 'Cash', icon: '💵' },
      { value: 'CARD', label: 'Card', icon: '💳' },
      { value: 'MOBILE_PAY', label: 'Mobile Pay', icon: '📲' },
      { value: 'GIFT_CARD', label: 'Gift Card', icon: '🎁' },
      { value: 'OTHER', label: 'Other', icon: '📝' },
    ];
  }
  // India: unchanged legacy set
  return [
    { value: 'CASH', label: 'Cash', icon: '💵' },
    { value: 'CARD', label: 'Card', icon: '💳' },
    { value: 'UPI', label: 'UPI', icon: '📱' },
    { value: 'WALLET', label: 'Wallet', icon: '👛' },
    { value: 'OTHER', label: 'Other', icon: '📝' },
  ];
}
